import actions from "./setup-actions";
export default { ...actions };
